import getObjectDefinitions from './getObjectDefinitions';
const getMapOf = (keyProp, valueProp) => {
  return getObjectDefinitions().reduce((map, objectDefinition) => {
    const key = objectDefinition.get(keyProp);
    const value = objectDefinition.get(valueProp);
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    map[key] = value;
    return map;
  }, {});
};
const shouldEnableUseInAssociations = (objectDefinition, {
  isUngated,
  hasScope
}) => {
  const isEnabled = objectDefinition.get('enableAsAssociatedType');
  if (!isEnabled) {
    return false;
  }
  const hasAccess = objectDefinition.get('hasAccess');
  return hasAccess(isUngated, hasScope);
};
const ObjectDefinitionProvider = {
  getEnabledForAssociations: (...args) => getObjectDefinitions().filter(record =>
  // @ts-expect-error ts-migrate(2556) FIXME: A spread argument must either have a tuple type or... Remove this comment to see the full error message
  shouldEnableUseInAssociations(record, ...args)),
  getAll: () => getObjectDefinitions(),
  getFiltered: (...args) =>
  // @ts-expect-error ts-migrate(2556) FIXME: A spread argument must either have a tuple type or... Remove this comment to see the full error message
  getObjectDefinitions().filter(...args),
  getById: id => getObjectDefinitions().find(({
    objectTypeId
  }) => id === objectTypeId),
  getMapOf
};
export default ObjectDefinitionProvider;